import { getCSSVar } from "utils/styling";

export const buildEnergyAnalysisAxisMax = (value: number, targetTickCount = 5) => {
  const safeValue = Math.max(value, 1);
  const roughInterval = safeValue / targetTickCount;
  const magnitude = 10 ** Math.floor(Math.log10(roughInterval));
  const normalized = roughInterval / magnitude;
  const multiplier = normalized <= 1 ? 1 : normalized <= 2 ? 2 : normalized <= 5 ? 5 : 10;
  const interval = multiplier * magnitude;
  return { interval, max: Math.ceil(safeValue / interval) * interval };
};

export const withEnergyAnalysisChartStyle = <Option extends object>(option: Option) => {
  const styledOption = option as Option & {
    grid?: Record<string, unknown>;
    legend?: Record<string, unknown> & { textStyle?: Record<string, unknown> };
    textStyle?: Record<string, unknown>;
  };
  const fontFamily = getCSSVar("--font-primary");
  const textColor = getCSSVar("--color-foreground-secondary");
  return {
    ...styledOption,
    grid: {
      bottom: 48,
      containLabel: true,
      left: 16,
      right: 24,
      top: 24,
      ...styledOption.grid,
    },
    legend: {
      bottom: 0,
      left: 10,
      orient: "horizontal",
      right: 40,
      type: "scroll",
      ...styledOption.legend,
      textStyle: {
        color: textColor,
        fontFamily,
        fontSize: 12,
        fontWeight: 400,
        ...styledOption.legend?.textStyle,
      },
    },
    textStyle: {
      color: textColor,
      fontFamily,
      fontSize: 12,
      fontWeight: 400,
      ...styledOption.textStyle,
    },
  };
};
